import React from 'react';

import FormBooking from "../FormBooking";
import TableauToolbar from "./TableauToolbar";
import BookingBar from "./BookingBar";
import useBookingsPlanner from "./useBookingsPlanner";
import {useMainLayout} from "../../../layouts/Main";
import Planner, {usePlanner} from "../../../components/Planner";
import Timeline from "../../../components/Planner/Timeline";
import MonthVertical from "../../../components/Planner/MonthVertical";
import ApartmentSwiper from "./ApartmentSwiper";

import Fab from "@mui/material/Fab";
import Container from "@mui/material/Container";
import AddIcon from '@mui/icons-material/Add';
import Box from "@mui/material/Box";


const renderCalendarItem = function (calendarItem, {rightCut, leftCut, isCentralSegment}) {
    return <BookingBar calendarItem={calendarItem}
                       rightCut={rightCut}
                       leftCut={leftCut}
                       isCentralSegment={isCentralSegment}/>
}

const Tableau = ({accommodations, bookings}) => {
    const bookingPlanner = useBookingsPlanner({accommodations, bookings});
    const {isMobile} = useMainLayout();

    return <Container disableGutters={isMobile} maxWidth={false} sx={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
        <Planner minDate={bookingPlanner.minDate}
                 maxDate={bookingPlanner.maxDate}
                 initialDate={bookingPlanner.initialDate}
                 eventsLoader={bookingPlanner.bookingLoader}  // depends on the view mode
                 renderEvent={renderCalendarItem}
                 resources={bookingPlanner.timeline.resources}  // only needed for the timeline
                 onSelect={bookingPlanner.handleSelect}
        >
            <PlannerContent accommodations={accommodations} {...bookingPlanner}/>
        </Planner>
    </Container>

}

const PlannerContent = ({accommodations, ...bookingPlanner}) => {
    const {isMobile} = useMainLayout();
    const {goToDate, handleClickOutside} = usePlanner();

    const handleAfterCreateBooking = async (booking) => {
        goToDate(booking.getArrival());
        bookingPlanner.handleAfterCreateBooking(booking);
    }

    // We need a Box with display flex and flexGrow 1 to make the planner
    // month vertical view to fill the available space
    return <Box onClick={handleClickOutside} sx={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
        { !isMobile && <TableauToolbar selectedViewMode={bookingPlanner.viewMode}
                                       onChangeViewMode={bookingPlanner.handleChangeViewMode}/> }

        { bookingPlanner.viewMode === 'timeline' && <Timeline/> }

        {
            bookingPlanner.viewMode === 'month-vertical' &&
            <ApartmentSwiper accommodations={accommodations}
                             accommodationUnitSelector={bookingPlanner.accommodationUnitSelector}>
                <MonthVertical/>
            </ApartmentSwiper>
        }

        <Fab variant="extended"
             color="primary"
             size='medium'
             sx={{position: "fixed", bottom: 0, right: 0, mr: {xs: 2, md: 4}, mb: {xs: 2, md: 4}}}
             onClick={bookingPlanner.openFormBooking}>
            <AddIcon sx={{mr: 1}}/>
            Aggiungi
        </Fab>

        {
            bookingPlanner.formBooking.show &&
            <FormBooking booking={bookingPlanner.defaultNewBooking}
                         accommodations={accommodations}
                         afterCreate={handleAfterCreateBooking}
                         onClose={bookingPlanner.closeFormBooking} />
        }
    </Box>
}

export default Tableau;